import gql from 'graphql-tag'
import { Fragment } from './fragment'

export const query = gql`
  ${Fragment}
  query fetchAppraisalResponse($id: Int!) {
    records: purchase_appraisal_response_by_pk(id: $id) {
      ...AppraisalResponseForm
    }
  }
`

export default query
